import Immutable from 'immutable';

export default Immutable.fromJS({
  errors   : null,
  isActive : false,
  result   : null,
});
